import { ErrorMessage, Field } from 'formik';
import useReportFieldError from '@/hooks/useReportFieldError';

const Input = ({
  id,
  title,
  name,
  type = 'text',
  labelClassName = '',
  inputClassName = '',
  ...props
}) => {
  useReportFieldError(name);

  // checkbox
  if (type === 'checkbox') {
    return (
      <div className='flex items-start gap-1.5 lg:gap-3'>
        <Field
          className="checked:border-primary checked:bg-primary relative size-4 min-w-5 cursor-pointer appearance-none rounded-md border border-[#E4E4F9] after:invisible after:absolute after:start-1/2 after:top-1/2 after:ms-2 after:mt-1 after:size-6 after:-translate-y-1/2 after:text-sm after:text-white after:content-['✓'] checked:after:visible max-lg:after:text-xs lg:size-5 lg:after:mt-0.5 ltr:after:-translate-x-1/2 rtl:after:translate-x-1/2"
          type='checkbox'
          name={name}
          id={name}
          {...props}
        />
        <label className={`cursor-pointer ${labelClassName}`} htmlFor={name}>
          {title}
        </label>
        <ErrorMessage
          name={name}
          component='p'
          className='text-xs text-red-600 lg:text-sm'
        />
      </div>
    );
  }

  if (type === 'date') {
    return (
      <div className='flex flex-col'>
        <label className={`max-lg:text-sm ${labelClassName}`} htmlFor={id}>
          {title}
        </label>
        <Field
          type='date'
          name={name}
          id={id}
          {...props}
          className='mt-1 flex-1 rounded-lg border border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm'
        />
        <ErrorMessage
          name={name}
          component='p'
          className='text-xs text-red-600 lg:text-sm'
        />
      </div>
    );
  }

  return (
    <div className='flex flex-col'>
      <label className={`max-lg:text-sm ${labelClassName}`} htmlFor={id}>
        {title}
      </label>
      <Field
        name={name}
        id={id}
        className={`mt-1 flex-1 rounded-lg border border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm ${inputClassName}`}
        {...props}
      />
      <ErrorMessage
        name={name}
        component='p'
        className='text-xs text-red-600 lg:text-sm'
      />
    </div>
  );
};

export default Input;
